import React from 'react';

// WidgetLayout: A minimal layout for the embeddable widget.
// No sidebar, no header, no footer. Just content.
// Background can be transparent or styled as needed.

const WidgetLayout = ({ children }) => {
    return (
        <div style={{
            width: '100%',
            height: '100vh',
            overflow: 'hidden',
            backgroundColor: 'transparent', // Ensure it blends if needed, or set to 'white'
            display: 'flex',
            flexDirection: 'column'
        }}>
            {children}
        </div>
    );
};

export default WidgetLayout;
